import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';

const LoaderWrapper = styled('div')({
  position: 'relative',
  display: 'inline-flex'
});

const CustomSvg = styled('svg')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  animation: 'rotate 1.4s linear infinite',
  '@keyframes rotate': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  }
});

const Loader: React.FC = () => (
  <LoaderWrapper>
    <CircularProgress size={64} style={{ opacity: 0 }} />{' '}
    {/* Hidden CircularProgress for animation */}
    <CustomSvg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 24.1938C18.6274 24.1938 24 18.8213 24 12.1938C24 5.56643 18.6274 0.193848 12 0.193848C5.37258 0.193848 0 5.56643 0 12.1938C0 18.8213 5.37258 24.1938 12 24.1938ZM12 22.1938C17.5228 22.1938 22 17.7167 22 12.1938C22 6.671 17.5228 2.19385 12 2.19385C6.47715 2.19385 2 6.671 2 12.1938C2 17.7167 6.47715 22.1938 12 22.1938Z"
        fill="url(#paint0_angular_564_871)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7818 9.79446C23.3296 9.7238 23.8309 10.1105 23.9016 10.6583C23.9673 11.1675 24.0002 11.6804 24.0002 12.1938C24.0002 12.7461 23.5525 13.1938 23.0002 13.1938C22.4479 13.1938 22.0002 12.7461 22.0002 12.1938C22.0002 11.7659 21.9727 11.3385 21.918 10.9142C21.8473 10.3665 22.2341 9.86513 22.7818 9.79446Z"
        fill="#fff"
      />
      <defs>
        <radialGradient
          id="paint0_angular_564_871"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12 12.1938) scale(12)"
        >
          <stop stopColor="#fff" stopOpacity="0" />
          <stop offset="0.0001" stopColor="#fff" stopOpacity="0" />
          <stop offset="1" stopColor="#fff" />
        </radialGradient>
      </defs>
    </CustomSvg>
  </LoaderWrapper>
);

export default Loader;
